// extracted by mini-css-extract-plugin
export var stepActive = "_1g-3";
export var stepCompleted = "_1g-4";
export var stepConnectorLine = "_1g-b";
export var stepIndicatorCircle = "_1g-6";
export var stepIndicatorCircleCompleted = "_1g-7";
export var stepIndicatorCircleDefault = "_1g-8";
export var stepIndicatorTextCompleted = "_1g-9";
export var stepIndicatorTextDefault = "_1g-a";
export var stepPending = "_1g-5";
export var wizardContainer = "_1g-1";
export var wizardContent = "_1g-2";
export var wizardModal = "_1g-0";